import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { isValidElement } from 'react';
import Spin from '../Spin';
import { PureComponent } from '../component';
import { uploadClass } from './styles';
import Button from '../Button';
import Upload from './Upload';
import { isRTL } from '../config';

var SPIN = function SPIN(color) {
  return (
    /*#__PURE__*/
    React.createElement("span", {
      className: uploadClass('bg-spin')
    },
    /*#__PURE__*/
    React.createElement(Spin, {
      size: 10,
      name: "ring",
      color: color
    }))
  );
};

var handleKeyDown = function handleKeyDown(e) {
  if (e.keyCode === 13) e.target.click();
};

var DefaultProps = {
  type: 'primary',
  size: 'default',
  outline: false
};

var Progress =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Progress, _PureComponent);

  var _super = _createSuper2(Progress);

  function Progress(props) {
    var _this;

    _classCallCheck(this, Progress);

    _this = _super.call(this, props);
    _this.handleStart = void 0;
    _this.handleOver = void 0;
    _this.state = {
      progress: -1
    };
    _this.handleError = _this.handleError.bind(_assertThisInitialized(_this));
    _this.handleSuccess = _this.handleSuccess.bind(_assertThisInitialized(_this));
    _this.handleProgress = _this.handleProgress.bind(_assertThisInitialized(_this));
    _this.handleStart = _this.handleChange.bind(_assertThisInitialized(_this), 0);
    _this.handleOver = _this.handleChange.bind(_assertThisInitialized(_this), -1);
    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Progress, [{
    key: "handleChange",
    value: function handleChange(p) {
      this.setState({
        progress: p
      });
    }
  }, {
    key: "handleProgress",
    value: function handleProgress(file) {
      this.handleChange(file.process);
    }
  }, {
    key: "handleError",
    value: function handleError(xhr, file) {
      var onError = this.props.onError;
      var msg;
      if (onError) msg = onError(xhr, file);
      this.handleOver();
      return msg;
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess(value) {
      var onSuccess = this.props.onSuccess;
      var result = value;

      if (onSuccess) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // @ts-ignore
        result = onSuccess.apply(void 0, [value].concat(args));
      }

      this.handleOver();
      return result;
    }
  }, {
    key: "handleUpload",
    value: function handleUpload(e) {
      var uploading = this.state.progress >= 0;
      if (uploading) e.stopPropagation();
    }
  }, {
    key: "renderLoadingView",
    value: function renderLoadingView(color) {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          loading = _this$props.loading;
      return (
        /*#__PURE__*/
        isValidElement(loading) ?
        /*#__PURE__*/
        React.createElement("span", null, loading) :
        /*#__PURE__*/
        React.createElement("span", null, SPIN(color), typeof loading === 'string' ? loading : placeholder)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          placeholder = _this$props2.placeholder,
          type = _this$props2.type,
          size = _this$props2.size,
          outline = _this$props2.outline,
          others = _objectWithoutProperties(_this$props2, ["placeholder", "type", "size", "outline"]);

      var uploading = this.state.progress >= 0;

      var style = _defineProperty({}, isRTL() ? 'left' : 'right', uploading ? "".concat(100 - this.state.progress, "%") : '100%');

      return (
        /*#__PURE__*/
        React.createElement(Upload, Object.assign({}, others, {
          limit: undefined,
          onProgress: this.handleProgress,
          onStart: this.handleStart,
          showUploadList: false,
          onError: this.handleError,
          onSuccess: this.handleSuccess
        }),
        /*#__PURE__*/
        React.createElement(Button, {
          tabIndex: others.disabled ? -1 : 0,
          disabled: others.disabled,
          className: uploadClass('button', uploading && 'uploading'),
          type: type,
          size: size,
          outline: outline,
          onClick: this.handleUpload,
          onKeyDown: handleKeyDown
        }, uploading && [
        /*#__PURE__*/
        React.createElement("div", {
          key: "cover",
          className: uploadClass('cover')
        }),
        /*#__PURE__*/
        React.createElement("div", {
          key: "bg",
          style: style,
          className: uploadClass('bg')
        }, this.renderLoadingView('#fff'))],
        /*#__PURE__*/
        React.createElement("span", null, uploading ? this.renderLoadingView() : placeholder)))
      );
    }
  }]);

  return Progress;
}(PureComponent);

Progress.defaultProps = DefaultProps;
export default Progress;